// External Imports
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { stringify } from 'query-string';
import omit from 'lodash/fp/omit';
import PropTypes from 'prop-types';
import React from 'react';
import set from 'lodash/fp/set';

// Internal Imports
import { actionRequestNextPage } from '../../actions/index.js';
import { ARCHIVE } from '../../config/types/content/component.js';
import { CONTENT_ARCHIVE } from '../../config/types/prop.js';
import { createGetComponentByContentType } from '../../selectors/createGetComponent.js';
import { getContentArchive } from '../../selectors/getContentArchive.js';
import { getEdition } from '../../selectors/getEdition.js';
import { getLoading } from '../../selectors/index.js';
import { getMatch } from '../../selectors/getMatch.js';
import { getModules } from '../../selectors/getModules.js';
import { options } from '../../config/reactRedux.js';
import { WithLoader } from '../Hoc/WithLoader/WithLoader.jsx';

// Component Definition
function ContentArchive(props) {
  const { component: Archive } = props;
  return (
    <div>
      {/* eslint-disable-next-line react/jsx-props-no-spreading -- props are shared by all Archive components, so spreading simplifies the code */}
      <Archive {...omit(['component'], props)} />
    </div>
  );
}

ContentArchive.propTypes = {
  ...CONTENT_ARCHIVE,
  component: PropTypes.elementType.isRequired,
  modules: PropTypes.object, // eslint-disable-line react/forbid-prop-types -- dynamically built
};

ContentArchive.defaultProps = {
  modules: {},
};

const mapStateToProps = (state) => {
  const contentArchive = getContentArchive(state);
  const loading = getLoading(state);
  const getComponent = createGetComponentByContentType(contentArchive.contentType, ARCHIVE);
  const component = getComponent(state);
  const match = getMatch(state);

  return {
    ...contentArchive,
    component,
    currentEdition: getEdition(state),
    loading: loading.content || !component,
    loadingMore: loading.more,
    match,
    modules: getModules(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  createOnChangeFilter: (url, query) => (changeEvent) => {
    changeEvent.preventDefault();

    const { name, value } = changeEvent.target;
    const newQuery = stringify(set(name, value || undefined, query), { arrayFormat: 'bracket' });

    dispatch(push(`${url}?${newQuery}`));
  },
  onLoadMore: (clickEvent) => {
    clickEvent.preventDefault();
    dispatch(actionRequestNextPage());
  },
});

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const {
    match: { url, query },
  } = stateProps;
  const { createOnChangeFilter } = dispatchProps;
  return {
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    onChangeFilter: createOnChangeFilter(url, query),
  };
};

const withRedux = connect(mapStateToProps, mapDispatchToProps, mergeProps, options);
const ContentArchiveHoc = withRedux(WithLoader(ContentArchive));

// Module Exports
export { ContentArchiveHoc as ContentArchive };
